<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.question')"
    namespace=""
    resource="questions"
    :actionColumnProps="{ width: 260 }"
    :before-submit="beforeSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { QUESTION_KINDS } from '@/constants';
import _ from 'lodash';

@Component
export default class Questions extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'content_cont',
        label: this.$t('question.content'),
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'enabled_eq',
        label: this.$t('question.enabled'),
        renderCell: {
          component: 'switch'
        }
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'kind',
        label: this.$t('question.kind'),
        width: 120,
        renderCell: (h, { props: { value } }) => {
          return <span>{this.$t(`question.kinds.${value}`)}</span>
        }
      },
      {
        prop: 'content',
        label: this.$t('question.content')
      },
      {
        prop: 'position',
        label: this.$t('question.position')
      },
      {
        prop: 'enabled',
        label: this.$t('question.enabled'),
        width: 80,
        renderCell: 'bool'
      },
      type === 'show' && {
        prop: 'position',
        label: this.$t('question.position'),
      },
      {
        prop: 'options',
        label: this.$t('model.option'),
        renderCell: (h, { props: { value } }) => {
          return (<div>
            {_.map(value, (v, i) => <div>{i + 1}. {v.content}</div>)}
          </div>)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'kind',
        label: this.$t('question.kind'),
        renderCell: {
          component: 'select',
          required: true,
          props: {
            options: _.map(QUESTION_KINDS, (value) => ({ label: this.$t(`question.kinds.${value}`), value: value }))
          }
        }
      },
      {
        prop: 'content',
        label: this.$t('question.content'),
        renderCell: {
          component: 'textarea',
          required: true,
          props: {
            autosize: { minRows: 2 }
          }
        }
      },
      {
        prop: 'position',
        label: this.$t('question.position'),
        renderCell: {
          component: 'input',
          hint: this.$t('hints.positionColumn'),
          props: {
            type: 'number'
          }
        },
      },
      {
        prop: 'options',
        label: this.$t('model.option'),
        renderCell: {
          component: 'nestForm',
          required: true,
          props: {
            columns: [
              {
                prop: 'content',
                label: this.$t('option.content'),
                renderCell: {
                  component: 'textarea',
                  required: true,
                  props: {
                    autosize: { minRows: 2 }
                  }
                }
              },
              {
                prop: 'position',
                label: this.$t('option.position'),
                renderCell: {
                  component: 'input',
                  hint: this.$t('hints.positionColumn'),
                  props: {
                    type: 'number'
                  }
                },
              }
            ]
          }
        }
      }
    ];
  }

  beforeSubmit({ state: { data } }) {
    data.options_attributes = data.options
    return data
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handleToggleEnable = async () => {
      await this.$autoLoading(this.$request.put(`/questions/${row.id}`, { enabled: !row.enabled }));
      this.$message.success(this.$t('bean.updateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'questions.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: `${row.enabled ? this.$t('question.disable') : this.$t('question.enable')}`,
          type: 'primary',
          can: 'questions.update'
        },
        on: {
          confirm: handleToggleEnable
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'questions.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions() {
  // batchActions({ selection }, { remove, reload }) {
    return [
      // () => <el-button onClick={() => console.log(selection)}>批处理({ selection.length })</el-button>
    ];
  }

}


export const route = [
  {
    path: '/questions',
    name: 'questions.index',
    component: Questions,
    props: {
      type: 'index',
    }
  },
  {
    path: '/questions/new',
    name: 'questions.new',
    component: Questions,
    props: {
      type: 'new',
    }
  },
  {
    path: '/questions/:id',
    name: 'questions.show',
    component: Questions,
    props: {
      type: 'show',
    }
  },
  {
    path: '/questions/:id/edit',
    name: 'questions.edit',
    component: Questions,
    props: {
      type: 'edit'
    }
  }
]
</script>
